import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD, getcurrTime } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { alarm_about, project_list, building_list, floor_list } from '@/api/pests';
import ImageMap from '@/view/components/imageMap/imageMap';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    var _formModel;

    return {
      axis: [],
      //已存在坐标
      imageSrc: null,
      floorListData: [],
      //楼层列表
      buildingListData: [],
      //建筑物列表
      projectListData: [],
      //项目记录
      alarmTypeData: [],
      //设备分类
      handleTypeData: [],
      //设备用途
      defaultList: [],
      maintainList: [],
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 3,
      BMap: null,
      position: {
        lng: 0,
        lat: 0
      },
      uploadList: [],
      refName: 'refName',
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      fileName: 'image',
      fileData: {
        client_id: ""
      },
      format: ['jpg', 'jpeg', 'png'],
      visible: false,
      imgName: '',
      uploadData: {
        client_id: null
      },
      uploadHeaders: {
        "Authorization": getToken()
      },
      proAttrFile: {},
      formModel: (_formModel = {
        device_name: null,
        //设备名称
        device_id: null,
        //设备ID
        device_code: null,
        //设备编码
        alarm_type_code: null,
        //设备分类编码
        handle_type_code: null,
        //设备用途编码
        project_code: null,
        //项目编码
        building_code: null,
        //建筑物编码
        floor_code: null,
        //楼层编码
        remark: null,
        //备注
        file_path: null,
        //设备图
        x_axis: '1',
        y_axis: '1',
        handle_user_time: null,
        handle_user_name: null
      }, _defineProperty(_formModel, "handle_type_code", null), _defineProperty(_formModel, "file_url", null), _formModel),
      formRules: {
        handle_user_time: [{
          required: true,
          message: '处理时间不能为空',
          trigger: 'change'
        }],
        handle_user_name: [{
          required: true,
          message: '处理人不能为空',
          trigger: 'blur'
        }],
        handle_type_code: [{
          required: true,
          message: '处理方式不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {}
  },
  components: {
    ImageMap: ImageMap
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    },
    getUser: function getUser() {
      return this.$store.state.user.userInfo;
    }
  },
  methods: (_methods = {
    timeChange: function timeChange(val) {
      this.$set(this.formModel, 'handle_user_time', val);
    },

    /**
     * 获取楼层
     */
    getFloor: function getFloor(val, callback) {
      for (var i = 0; i < this.floorListData.length; i++) {
        var list = this.floorListData[i];

        if (val === list.floor_code) {
          this.imageSrc = list.file_url;
          break;
        }
      }

      if (callback) {
        callback();
      }
    },

    /**
     * 获取坐标
     */
    getAxis: function getAxis(axis) {
      this.$set(this.formModel, 'x_axis', axis.x);
      this.$set(this.formModel, 'y_axis', axis.y);
    },

    /**
     * 项目改变
     */
    changeProject: function changeProject(val, callback) {
      var _this = this;

      this.$set(this.formModel, 'building_code', null);
      this.$set(this.formModel, 'floor_code', null);
      building_list({
        page: 0,
        page_size: 15,
        project_code: val
      }).then(function (res) {
        if (res.result === 0) {
          _this.buildingListData = res.body.list || [];

          if (callback) {
            callback();
          }
        } else {}
      });
    },

    /**
     * 改变建筑物
     */
    changeBuilding: function changeBuilding(val, callback) {
      var _this2 = this;

      this.$set(this.formModel, 'floor_code', null);
      floor_list({
        page: 0,
        page_size: 15,
        building_code: val
      }).then(function (res) {
        if (res.result === 0) {
          _this2.floorListData = res.body.list || [];

          if (callback) {
            callback();
          }
        }
      });
    },
    handleView: function handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleMaxSize: function handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '请上传小于4M的图片'
      });
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      return true;
    },

    /**
     * 上传进度
     */
    handleProgess: function handleProgess(event, file, fileList) {},

    /**
     * 维保开始日期
     */
    startChange: function startChange(val) {
      this.$set(this.formModel, 'maintain_start', val);
    },

    /**
     * 合同开始日期
     */
    contractTimeChange: function contractTimeChange(arr) {
      this.$set(this.formModel, 'contract_start', arr[0]);
      this.$set(this.formModel, 'contract_end', arr[1]);
    },
    //检查图片的width和height
    checkImageWH: function checkImageWH(file, width, height) {
      var self = this._vm;
      return new Promise(function (resolve, reject) {
        var filereader = new FileReader();

        filereader.onload = function (e) {
          var src = e.target.result;
          var image = new Image();

          image.onload = function () {
            if (width && this.width != width) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleWidth') + width
              });
              reject();
              self.spinShow = false;
            } else if (height && this.height != height) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleHeight') + height
              });
              reject();
              self.spinShow = false;
            } else {
              resolve();
            }
          };

          image.onerror = reject;
          image.src = src;
        };

        filereader.readAsDataURL(file);
      });
    },

    /**
     * 上传之前检查width,height
     */
    handleUploadImg: function handleUploadImg(file, width, height) {
      return this.checkImageWH(file, width, height);
    }
  }, _defineProperty(_methods, "handleRemove", function handleRemove(file, fileList, str) {
    this.$set(this.formModel, 'company_avatar', '');
    this.uploadList.splice(0);
  }), _defineProperty(_methods, "handleSuccess", function handleSuccess(res, file, str) {
    var vm = this;
    this.uploadList.splice(0);

    if (res.result === 0) {
      //to do
      this.$set(this.formModel, 'file_path', res.body.file_path);
      this.uploadList.push({
        status: 'finished',
        url: res.body.file_path,
        name: file.name
      });
    } else {
      //删除上传的对象
      this.$Message.error(res.errorMsg);
    }
  }), _defineProperty(_methods, "clientChange", function clientChange(val) {
    this.$set(this.fileData, 'client_id', val);
    this.hasDisabled = false;
  }), _defineProperty(_methods, "handleView", function handleView(name) {
    this.imgName = name;
    this.visible = true;
  }), _defineProperty(_methods, "handleFormatError", function handleFormatError(file) {
    this.$Notice.warning({
      title: '文件格式错误',
      desc: '请上传' + this.format.join(', ') + '类型文件'
    });
  }), _defineProperty(_methods, "init", function init() {
    var _this3 = this;

    //获取设备分类和用途
    alarm_about().then(function (res) {
      if (res.result === 0) {
        _this3.handleTypeData = res.body.handle_type || [];
      }
    }); //项目列表
    // project_list({page:0,page_size:15}).then(res=>{
    //   if(res.result===0){
    //     this.projectListData=res.body.list||[]
    //   }
    // })
  }), _methods),
  mounted: function mounted() {
    debugger;

    if (this.edit) {
      if (this.setData) {
        Object.assign(this.formModel, this.setData);
        this.uploadList.push({
          status: 'finished',
          url: this.setData.file_url,
          name: this.setData.file_path
        });
        this.$set(this, 'axis', [{
          x: this.setData.x_axis,
          y: this.setData.y_axis
        }]);
        console.log(this.axis);
        this.$set(this.formModel, 'contract_time', [formatYMD(this.setData.contract_start * 1000), formatYMD(this.setData.contract_end * 1000)]);
        this.$set(this.formModel, 'maintain_start', formatYMD(this.setData.maintain_start * 1000)); //获取当前时间和处理人

        var name = this.getUser;
        this.$set(this.formModel, 'handle_user_name', name.admin_real_name);
        var timeObj = getcurrTime();
        var currTime = timeObj.Y + '-' + timeObj.M + '-' + timeObj.d + ' ' + timeObj.time;
        this.$set(this.formModel, 'handle_user_time', currTime);
      }
    } else {}
  },
  created: function created() {
    this.init();
  }
};